import { isBoxLayout, isPinComponentLocked, pinSize, useUpdatePin } from '@lessonup/pin-renderer';
import { PinComponent } from '@lessonup/pins-shared';
import { BodyText, IconRotationAngle, SpaceBetween, spacing, styled } from '@lessonup/ui-components';
import React from 'react';
import {
  setPositionAction,
  setRotationAction,
} from '../../../../../utils/pinComponentSettings/sharedPinComponentSettings';
import { EditorTextField } from '../../EditorInputFields/EditorTextField';

const POSITION_INCREMENT_STEP = 5;

export interface BoxLayoutPositionSettingProps {
  pinComponent: PinComponent;
}

export const BoxLayoutPositionSetting: React.FC<BoxLayoutPositionSettingProps> = ({ pinComponent }) => {
  const dispatch = useUpdatePin();
  if (!isBoxLayout(pinComponent.layout)) return null;
  const isLocked = isPinComponentLocked(pinComponent);

  return (
    <>
      <SpaceBetween direction="x" spacing={spacing.size4} alignItems="center">
        <StyledBodyText>{'X'}</StyledBodyText>
        <StyledTextField
          id="x"
          type="number"
          value={pinComponent.layout.position.x}
          min={0}
          max={pinSize.width}
          step={POSITION_INCREMENT_STEP}
          onChange={(event) => {
            const action = setPositionAction(pinComponent, 'x', event);
            if (action) {
              dispatch(action);
            }
          }}
          disabled={isLocked}
        />
        <StyledBodyText>{'Y'}</StyledBodyText>
        <StyledTextField
          id="y"
          type="number"
          value={pinComponent.layout.position.y}
          min={0}
          max={pinSize.height}
          step={POSITION_INCREMENT_STEP}
          onChange={(event) => {
            const action = setPositionAction(pinComponent, 'y', event);
            if (action) {
              dispatch(action);
            }
          }}
          disabled={isLocked}
        />
      </SpaceBetween>
      <SpaceBetween direction="x" spacing={spacing.size4} alignItems="center">
        <IconRotationAngle />
        <StyledTextField
          id="rotation"
          type="number"
          value={pinComponent.layout.rotation}
          min={-180}
          max={180}
          step={1}
          onChange={(event) => {
            const action = setRotationAction(pinComponent, event);
            if (action) {
              dispatch(action);
            }
          }}
          disabled={isLocked}
        />
      </SpaceBetween>
    </>
  );
};

const StyledBodyText = styled(BodyText)`
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledTextField = styled(EditorTextField)`
  flex-grow: 1;
`;
